import { blueGrey } from "../../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ typography, spacing }) => ({
  label: {
    fontSize: typography.pxToRem(12),
    lineHeight: typography.pxToRem(14),
    color: blueGrey[500],
    display: "block",
    marginBottom: spacing(2)
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(4)
  },
  nameContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(2)
  }
}))
